import { render, staticRenderFns } from "./ListWithActions.vue?vue&type=template&id=dde3c2e8&"
import script from "./ListWithActions.vue?vue&type=script&lang=js&"
export * from "./ListWithActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports